import axios from './config/config-viva';

const defaultRoute = 'procedimentos/';

export default {
  list: (grupo = null) =>
    axios.get(`${defaultRoute}${grupo ? '?grupo=' + grupo : ''}`),
  findOne: async (id) => {
    const { data } = await axios.get(`${defaultRoute}${id}`)

    return data
  },
  findOneByDescription: async (procedureNameInList) => {
    const { data } = await axios.get(
      `${defaultRoute}procedure-by-description`,
      {
        params: {
          procedureNameInList,
        },
      }
    )

    return data
  },
  create: (procedimento) => axios.post(defaultRoute, procedimento),
  update: (id, procedimento) => axios.put(defaultRoute + id, procedimento),
  remove: (id) => axios.delete(defaultRoute + id),
}